import React from 'react'
import "./styles.css";


const PasswordError =  ()=> {
  return (
    <div className="error-message-a">
        <p>Invalid password</p>
        <p>Your password should be at least 8 characters</p>
        <ul>
        <li>At least one uppercase & one lower case letter</li>
        <li>At least one special character</li>
        <li>At least one numeric digit</li>
        </ul>
  </div>
  )
}

export default PasswordError